import { LoadingButton } from '@mui/lab';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Button,
  IconButton,
  Box,
  Typography,
} from '@mui/material';
import { FC } from 'react';
import { toast } from 'react-toastify';

import { useSendReminder } from '@features/digitalOnboarding/hooks/useSendReminder';
import  CloseIcon  from '@mui/icons-material/Close';
import { ReminderIcon } from '../../../../vectors/index';
import { Done } from '@mui/icons-material';

type SendReminderModalProps = {
  isOpen: boolean;
  handleClose: () => void;
  applicationId: number;
};

const SendReminderModal: FC<SendReminderModalProps> = ({
  isOpen,
  handleClose,
  applicationId,
}) => {
  const { sendReminder, isSendingReminder } = useSendReminder();

  const handleSend = () =>
    sendReminder(
      { application_id: applicationId },
      {
        onSuccess: () => {
          toast.success('Reminder sent to the applicant');
          handleClose();
        },
      },
    );

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <IconButton
          sx={{ position: 'absolute', right: 8, top: 8 }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          gap="10px"
        >
          <ReminderIcon />
          <Typography variant="h5">
            Are you sure you want to send a reminder to the applicant?
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <LoadingButton
            variant="contained"
            startIcon={<Done />}
            loading={isSendingReminder}
            onClick={handleSend}
          >
            Yes, Send a Reminder
          </LoadingButton>
          <Button
            startIcon={<CloseIcon />}
            color="secondary"
            variant="outlined"
            onClick={handleClose}
          >
            No, Go Back
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default SendReminderModal;
